import { ArticleType } from "@coworker/types/lib/tasks/constants";
import { Item } from "../../../shared/types/item";
import { ItemExpectedDeliveryResponse } from "../../../shared/types/itemExpectedDeliveryResponse";
import { ProductImage } from "./ProductImage";
import { StockAndInDeliveryInfo } from "./StockAndIndeliveryInfo";
import ProductCardCss from "./product-card.module.css";
import { isLocalCombinationArticle } from "@coworker/app/src/components/RoomSettings/Helpers/articleHelpers";

interface ProductCardPresentationProps {
  product: Item;
  available: number;
  elevated: number | null;
  color: string | undefined;
  isStockLoading: boolean;
  itemDeliveryData: ItemExpectedDeliveryResponse | undefined;
  isDeliveryDataLoading: boolean;
  handleProductClick?: () => void;
  className?: string | undefined;
}

export const ProductCardPresentation = ({
  product,
  available,
  elevated,
  color,
  isStockLoading,
  itemDeliveryData,
  isDeliveryDataLoading,
  handleProductClick,
  className,
}: ProductCardPresentationProps) => {
  return (
    <div
      className={`${ProductCardCss["product-card"]} ${className}`}
      onClick={handleProductClick}
    >
      <ProductImage product={product} />
      <div className={ProductCardCss["product-info-wrapper"]}>
        <div className={ProductCardCss["product-name"]}>{product.name}</div>
        <div className={ProductCardCss["product-number"]}>
          {product.noFormatted}
        </div>
        <div className={ProductCardCss["product-description"]}>
          {product.description}
        </div>
        {!isLocalCombinationArticle(product.type as ArticleType) && (
          <StockAndInDeliveryInfo
            available={available}
            elevated={elevated}
            color={color}
            isStockLoading={isStockLoading}
            itemDeliveryData={itemDeliveryData}
            isDeliveryDataLoading={isDeliveryDataLoading}
          />
        )}
      </div>
    </div>
  );
};
